import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./top100players.scss";
import Pages from "./Top100Pages";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import LogoutIcon from "@mui/icons-material/Logout";
import SiteButton from "../../../ui/SiteButton";
import { searchPlayers } from "../../../../store/reducers/reducerWeb";
import { useLang } from "../../../../i18n/LangContext";

const Top10Players = () => {
  const dispatch = useDispatch();
  const { t } = useLang();
  const [data, setData] = useState([]);
  const [numberPage, setNumberPage] = useState(0);
  const [search, setSearch] = useState("");
  const [copySearch, setCopySearch] = useState("");

  const [loader, setLoader] = useState(false);
  const [formSend, setFormSend] = useState(false);

  const top100Players = useSelector(
    (state) => state.reducerWeb.top100Players.data
  );

  const classes = useStyles();

  useEffect(() => {
    if (!formSend) {
      setData(Array.isArray(top100Players) ? top100Players : []);
    }
  }, [top100Players, formSend]);

  const result = useMemo(() => {
    let n = 3;
    let res = [[], [], []];

    if (data.length <= 29) {
      n = 1;
      res = [[]];
    } else if (data.length > 29 && data.length < 58) {
      n = 2;
      res = [[], []];
    } else if (data.length >= 58) {
      n = 3;
      res = [[], [], []];
    }

    const wordsPerLine = Math.ceil(data.length / n);

    for (let line = 0; line < n; line++) {
      for (let i = 0; i < wordsPerLine; i++) {
        const value = data[i + line * wordsPerLine];
        if (!value) continue;
        res[line].push(value);
      }
    }

    return res;
  }, [data]);

  async function handleSubmit(e) {
    e.preventDefault();
    const q = search.trim();
    if (!q) {
      return;
    }

    setLoader(true);
    setCopySearch(q);
    setSearch("");
    setFormSend(true);
    setNumberPage(0);

    try {
      const rows = await dispatch(searchPlayers(q)).unwrap();
      setData(Array.isArray(rows) ? rows : []);
    } catch {
      setData([]);
    } finally {
      setLoader(false);
    }
  }

  function clearSearch() {
    setFormSend(false);
    setCopySearch("");
    setNumberPage(0);
    setData(Array.isArray(top100Players) ? top100Players : []);
  }

  return (
    <div className="containerTop100Players">
      <Box
        style={{ height: "100px", position: "relative" }}
        component="form"
        noValidate
        autoComplete="on"
        onSubmit={handleSubmit}
      >
        <div
          style={{
            position: "absolute",
            top: "-54px",
            bottom: 0,
            left: "90%",
            zIndex: "9999999",
          }}
        >
          {formSend && copySearch && (
            <LogoutIcon
              className="newCursor"
              onClick={clearSearch}
              sx={{
                color: "#AB9784",
                height: "30px",
                width: "30px",
              }}
            />
          )}
        </div>

        <>
          <TextField
            className={classes.root}
            size="small"
            id="outlined-multiline-flexible"
            label={t("search_player")}
            value={search}
            type="text"
            onChange={(e) => setSearch(e.target.value)}
          />

          {loader ? <CircularProgress sx={{ color: "#392613" }} /> : null}

          <SiteButton
            type="submit"
            variant="primary"
            className="buttonSearchRanking"
            disabled={loader}
          >
            {t("search")}
          </SiteButton>
        </>
      </Box>

      {formSend && !loader && data.length === 0 ? (
        <div style={{ textAlign: "center", color: "#ccc", marginBottom: 20 }}>
          No players found for &quot;{copySearch}&quot;
        </div>
      ) : null}

      <Pages
        numberPages={numberPage}
        OriginPages={data.length < 29 ? data : null}
        newPages={data.length < 29 ? null : result}
      />

      <div
        style={{
          marginTop: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowBackIosIcon
          className=" arrowIconsTop100"
          // onClick={() => setNumberPage(numberPage < 1 ? 0 : numberPage - 1)}
          onClick={() => setNumberPage((prev) => (prev <= 0 ? 0 : prev - 1))}
        />

        <div>
          <div>{`Page ${numberPage + 1} of ${result.length || 1}`}</div>
        </div>

        <ArrowForwardIosIcon
          className="arrowIconsTop100"
          onClick={() =>
            setNumberPage((prev) => {
              if (data.length <= 29) {
                return 0;
              }

              if (data.length >= 58) {
                return prev >= 2 ? 2 : prev + 1;
              }

              if (data.length > 29 && data.length < 58) {
                return prev >= 1 ? 1 : prev + 1;
              }

              return prev; // תמיד תחזיר ערך תקף!
            })
          }

          /*
          onClick={() =>
            setNumberPage(() => {
              if (data.length <= 29) {
                return 0;
              }

              if (data.length >= 58) {
                return numberPage == 2 ? 2 : numberPage + 1;
              }
            })
          }
*/
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "& .MuiOutlinedInput-input": {
      color: "white",
    },
    // "&:hover .MuiOutlinedInput-input": {
    //   color: "red",
    // },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "white",
    },
    "& .MuiInputLabel-outlined": {
      color: "white",
    },
    // "&:hover .MuiInputLabel-outlined": {
    //   color: "red",
    // },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "white",
    },
  },
});

export default Top10Players;
